export default __webpack_public_path__ + "static/media/graphql.61116f4f.svg";